// Store scroll position for off canvas
window.offCanvasScrollPosition = 0;

// Open off canvas content
window.openOffCanvas = (el) => {
    if(typeof el == 'undefined' || el == null || el.dataset.content == null || el.dataset.content == '') {
        return;
    }
    if(el.classList.contains('state--triggered')) {
        return;
    }
    let content = document.querySelector(el.dataset.content);
    if(content == null) {
        return;
    }
    el.classList.add('state--triggered');
    let overlay = document.querySelector('.offcanvas-overlay');
    let offcanvas = document.querySelector('.offcanvas-container');
    let offCanvasContent = document.querySelector('.offcanvas-content');
    let offCanvasTitle = offcanvas.querySelector('h4');
    offCanvasTitle.textContent = content.dataset.title;
    if(el.dataset.flash == 'true') {
        offCanvasTitle.classList.add('state--flash');
        setTimeout(() => {
            offCanvasTitle.classList.remove('state--flash');
        }, (typeof el.dataset.flashTimer != 'undefined' ? el.dataset.flashTimer : 2500));
    }
    overlay.classList.add('state--visible');
    offcanvas.dataset.trigger = el.dataset.content;
    offCanvasContent.append(content);
    offcanvas.classList.add('state--visible');
    overlay.addEventListener('click', window.closeOffCanvas);
    
    // Save scroll position and apply scroll lock
    window.offCanvasScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.add('overflow-hidden');
}

// Close off canvas content
window.closeOffCanvas = () => {
    let overlay = document.querySelector('.offcanvas-overlay');
    let offcanvas = document.querySelector('.offcanvas-container');
    let offCanvasContent = document.querySelector('.offcanvas-content');
    let contentContainer = document.querySelector('.offcanvas-content-holder');
    let content = document.querySelector('.offcanvas-content > *');
    let triggers = document.querySelectorAll('[data-content="'+offcanvas.dataset.trigger+'"]');
    offcanvas.querySelector('h4').textContent = '';
    overlay.classList.remove('state--visible');
    offcanvas.classList.remove('state--visible');
    if(content != null) contentContainer.append(content);
    if(triggers != null) {
        triggers.forEach((trigger) => trigger.classList.remove('state--triggered'));
    }
    
    // Restore scroll position
    document.body.classList.remove('overflow-hidden');
    window.scrollTo(0, window.offCanvasScrollPosition);
}